import { Text } from '@zillow/constellation-10';

import {
  type CompletenessScoreType,
  ListingScoreConstants,
  ZRAMListingScoreConstants,
} from '@zg-rentals/rental-revenue-components';
import { LoadingText } from '@zg-rentals/loading-components';

import { useSelector } from '../../../../selectors/useSelector';

import type { TextPropsInterface } from '@zillow/constellation-10';

type Props = {
  showIncompleteMessage: boolean;
  completenessScore: CompletenessScoreType;
  textStyle?: TextPropsInterface['textStyle'];
  isLoading?: boolean;
};

const Heading = ({ showIncompleteMessage, completenessScore, textStyle = 'body-bold', isLoading = false }: Props) => {
  const isMultifamily = useSelector((state) => state.properties.currentProperty.isMultifamily);

  if (isMultifamily && completenessScore?.rating && completenessScore.rating in ZRAMListingScoreConstants) {
    const { ratingPrefix, ratingText } =
      ZRAMListingScoreConstants[completenessScore.rating as keyof typeof ZRAMListingScoreConstants];
    return <Text textStyle={textStyle}>{`${ratingPrefix}${ratingText}`}</Text>;
  }

  const { textColor, ratingText } =
    ListingScoreConstants[completenessScore?.rating as keyof typeof ListingScoreConstants] || {};

  return (
    <LoadingText asChild={true} textStyle={textStyle} isLoading={isLoading} loadingWidth="10rem">
      <p>
        {showIncompleteMessage
          ? 'Your listing is '
          : `Your listing’s completeness ${completenessScore?.rating === 'needsImprovement' ? ' ' : 'is '}`}

        {<Text textStyle={textStyle} css={{ color: textColor }}>{`${ratingText}`}</Text>}
      </p>
    </LoadingText>
  );
};

export default Heading;
